export enum SnackBarType {
    Info = 'info',
    Warning = 'warning',
    Error = 'error'
  }